import React from "react";
import { useNavigate } from "react-router-dom";
import { Container, Col, Row } from "react-bootstrap";
//import MutualFund from "./../../../Images/mutualfund.png";
import MutualFund from "./../../../Images/home-products/mutual-fund.png";
import MfFaq from "./MfFaq/MfFaq";
import "./MFProduct.css";
function MFProduct() {
  let navigate = useNavigate();
  const routeChange = () => {
    let path = `/AllEquities`;
    navigate(path);
  };
  return (
    <>
      {/* <div>IPO Product testing</div> */}
      <section className="welcome-equity">
        <Container>
          <Row>
            <Col lg={4} md={6} sm={12}>
              <div className="welcome-img-block">
                <img className="img-fluid" src={MutualFund} alt="EquityImg" />
              </div>
            </Col>
            <Col lg={8} md={6} sm={12}>
              <div className="welcome-equity-beta">
                <h3>
                  <span>Mutual funds</span>
                </h3>
                <p>
                  A mutual fund is a financial vehicle that draws money from
                  investors and invests those funds in various securities. The
                  mutual fund's holdings are referred to as its portfolio.
                  Professional money managers manage the fund and allocate funds
                  in order to generate the best returns for the investors.
                  Mutual funds invest in a wide range of securities, and
                  performance is typically measured as the change in the fund's
                  total market cap, which is derived from the aggregation of the
                  underlying investments' performance.
                </p>
                {/* <a onClick={routeChange}>
                  <span>Explore</span>
                </a>
                <button type="button">Sign Up</button> */}
              </div>
            </Col>
          </Row>
        </Container>
      </section>
      <section className="why-equity-block">
        <Container className="add-border">
          <Row>
            <Col lg={12} md={12} sm={12}>
              <div className="why-equitie-inn">
                <h3>
                  <span>Why Mutual funds</span>
                </h3>
                <p>
                  Mutual funds provide a diverse range of investment solutions
                  to meet a variety of investment needs and risk profiles. There
                  are several reasons why investors choose mutual funds over
                  managing their portfolios directly.
                </p>
              </div>
              <div className="each-mf-main">
                <div className="each-mf-block">
                  <h5>Diversification</h5>
                  <p>
                    Never put all your eggs in one basket, in the same way,
                    Mutual funds managers invest in a range of companies and
                    industries according to the theme of the fund.
                  </p>
                </div>
                <div className="each-mf-block">
                  <h5>Regulated</h5>
                  <p>
                    Mutual funds are regulated by the Securities and exchange
                    board of India (SEBI) which monitors and regulates the
                    Indian capital and securities market while ensuring to
                    protect the interests of the investors, formulating
                    regulations and guidelines
                  </p>
                </div>
                <div className="each-mf-block">
                  <h5>Professional management</h5>
                  <p>
                    The fund manager is generally highly qualified and
                    experienced in markets and can be managing the portfolio
                    through research and investment with due diligence.
                  </p>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
      <MfFaq />
    </>
  );
}
export default MFProduct;
